import { Component, ChangeDetectionStrategy, inject, computed, signal, DestroyRef, OnInit } from '@angular/core';
import { NgClass } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { filter, interval, map, takeWhile } from 'rxjs';

import { SVG } from '@core/consts/SVGs';
import { PopupService } from '@shared/services/popup.service';
import { POPUPS, PopupTypes } from '@core/consts/popups';

import { ButtonComponent } from '../button/button.component';
import { getFormatedTime } from './utils/get-formated-time';

@Component({
  selector: 'mdcr-popup',
  templateUrl: './popup.component.html',
  styleUrl: './popup.component.scss',
  imports: [ButtonComponent, NgClass],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PopupComponent implements OnInit {
  private readonly popupService = inject(PopupService);
  private readonly destroyRef = inject(DestroyRef);

  public readonly popupType = this.popupService.buttonType;
  public readonly remainingTime = signal<number>(0);

  public readonly formattedTime = computed(() => getFormatedTime(this.remainingTime()));

  public readonly isErrorButton = computed(() => POPUPS[this.popupType()].color === 'error');

  public readonly hasSecondaryButton = computed(() => this.popupType() !== PopupTypes.TOO_MANY_ATTEMPTS);
  public readonly hasButtons = computed(
    () => this.popupType() !== PopupTypes.EARLY_WARNING && this.popupType() !== PopupTypes.LATE_WARNING,
  );

  public readonly POPUPS = POPUPS;
  public readonly SVG = SVG;

  public ngOnInit(): void {
    this.setTimer();
  }

  public onCancel(): void {
    this.popupService.closePopup();
  }

  public onButtonClick(): void {
    this.popupService.changeButtonState();
  }

  public onSecondaryButtonClick(): void {
    this.popupService.changeSecondaryButtonState();
  }

  private setTimer(): void {
    this.popupService
      .getTimer()
      .pipe(filter(Boolean), takeUntilDestroyed(this.destroyRef))
      .subscribe((time) => {
        this.remainingTime.set(time);
        this.startTimer();
      });
  }

  private startTimer(): void {
    interval(1000)
      .pipe(
        map(() => Math.max(this.remainingTime() - 1000, 0)),
        takeWhile((value) => value > 0, true),
      )
      .subscribe(() => this.remainingTime.update((time) => time - 1000));
  }
}
